/**
 * Default value for total price while there is no price yet calculated.
 */
export const TOTAL_PRICE_DEFAULT = '0.00';
